<template>
  <div class="color-card" :class="cssClass">
    <div class="columns is-mobile">
      <div class="column img-container" :class="imgClass || 'is-2'">
        <slot name="image" />
      </div>
      <div class="column header">
        <slot name="header" />
      </div>
    </div>
    <div class="body">
      <slot name="body" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Card",
  props: ["cssClass", "imgClass"],
}
</script>
